import { AddStaticText } from "../utils/AddStaticText";
import {
  enumBoxStyleSet,
  enumBoxSubTypes,
  enumBoxType,
  enumChartBoxInteractionMode,
  enumChartElement,
  enumContainerType,
  enumHierarchyTypes,
  kBoxStylesMarginH,
  kBoxStylesMarginV
} from "../constants";
import { QBasePanel } from "./QBasePanel";
import { QBSRightClick } from "./QBSRightClick";
import { QChartBox } from "./QChartBox";
import { TruncateText } from "../utils/TruncateText";
import { CenterIt } from "../utils/CenterIt";

export class QBoxStylesPanel extends QBasePanel {
  constructor() {
    super();
    this.fImageMgr = null;
    this.fBoxStylesMgr = null;
    this.fWSMgr = null;
    this.fRenderBoxSpacing = false;
    this.fOriginalLayout = null;
    this.fBasicViewPortFormatting = true;
    this.fDblClick = null;
  }

  PerformSelect(theElement, selectIt) {
    theElement.SetSelected(selectIt);
    this.fCurSelectedLayout = selectIt && theElement.GetLayout ? theElement.GetLayout() : null;
  }

  InitBoxStylesPanel(wsMgr, editingRibbon) {
    this.fWSMgr = wsMgr;
    this.fImageMgr = wsMgr.GetImageMgr();
    this.fUIColors = wsMgr.fUIColors;
    this.SetMarqueeEnabled(true);
    this.fBoxStylesMgr = wsMgr.GetBoxStylesMgr();
    this.fBoxStylesRibbon = editingRibbon;
    this.SetHideScrollBar(true);
    this.fWSMgr.PushPanel(this);
    this.InitializeExtras();
    this.OneTimePanelPrep();
    this.UpdatePanel();
  }

  DoResizePanel() {
    this.UpdatePanel(null);
  }

  SetBoxStylesDirty() {
    this.fWSMgr.fBoxStylesMgr.SetDirty();
  }

  AddContent() {
    var targetBox = null;

    var yPos = 0;
    var xPos = 0;

    var firstLayout = this.fCurSelectedLayout ? this.fCurSelectedLayout : this.GetSelectedLayout();

    var boxStyleSet = this.fBoxStylesMgr.CurrentBoxStyleSet();
    switch (boxStyleSet) {
      case enumBoxStyleSet.sharedboxstyles:
        this.fCurrentTab = "Shared";
        break;
      case enumBoxStyleSet.userboxstyles:
        this.fCurrentTab = "User";
        break;
      case enumBoxStyleSet.systemboxstyles:
        this.fCurrentTab = "System";
        break;
    }

    var m = this.fBoxStylesMgr;
    var visibleLayouts = m ? m.GetVisibleLayouts() : [];

    var availableWidth = this.GetWidth();

    var rowHeight = 0;
    for (var i = 0; i < visibleLayouts.length; i++) {
      var l = visibleLayouts[i];

      var outset = l.GetBorderOutset();
      var boxHeight = l.GetBoxHeight(false) + outset;
      var boxWidth = l.GetBoxWidth() + outset;
      xPos = xPos + outset;
      yPos = yPos + outset;
      if (xPos + boxWidth > availableWidth - kBoxStylesMarginH) {
        if (xPos != kBoxStylesMarginH) {
          yPos = yPos + rowHeight + kBoxStylesMarginV;
        }
        xPos = outset;
        rowHeight = boxHeight;
      } else rowHeight = Math.max(rowHeight, boxHeight);

      var aBox = new QChartBox();
      aBox.InitChartBox(
        l,
        this,
        xPos,
        yPos,
        enumChartBoxInteractionMode.boxstyle,
        null,
        null,
        false,
        null,
        false
      );
      aBox.SetEnableResizer(false);
      aBox.SetEnableExpander(false);

      aBox.SetHoverCode("!" + l.GetBoxStyleName());

      var labelY = yPos + boxHeight;
      var boxLabel = AddStaticText(
        this,
        0,
        labelY,
        l.GetBoxStyleName(),
        false,
        this.GetUIColors().GetHeaderTextColor()
      );
      if (l.fDirty) {
        boxLabel.SetItalic(true);
        boxLabel.SetLabel(l.GetBoxStyleName() + "*");
      }
      var newText = TruncateText(boxLabel.GetLabel(), boxLabel.GetFontString(), boxWidth);
      boxLabel.SetLabel(newText);
      boxLabel.AutoSize();
      boxLabel.SetPositionX(CenterIt(boxWidth, boxLabel.GetWidth()) + xPos);
      if (boxStyleSet && this.fDblClick) aBox.SetDblClickCmd(this.fDblClick);

      aBox.SetDraggable(false);
      if (
        this.fBoxStylesMgr?.fPendingScrollTarget != null &&
        l.fBoxStyleID === this.fBoxStylesMgr.fPendingScrollTarget
      ) {
        targetBox = aBox;
        this.fCurSelectedLayout = l;
      } else if (l == firstLayout) {
        targetBox = aBox;
      }
      xPos = xPos + kBoxStylesMarginH + boxWidth;
    }

    if (targetBox != null) {
      this.DoSelectElement(targetBox, true);
    }

    this.SizePanel(this.fWidth, yPos + rowHeight + 20);

    return { width: 0, height: yPos + rowHeight + 20 };
  }

  PostStandardResize() {
    this.UpdatePanel(null);
  }

  RemoveLayouts() {
    //var moreboxes = true;
    var layouts = this.GetSelectionList(enumChartElement.chartBox);
    while (layouts.length > 0) {
      var theBox = layouts.pop();
      this.fBoxStylesMgr.RemoveLayout(theBox.GetLayout());
      //moreboxes = this.RemoveLayout(true);
    }

    this.UpdatePanel(null);
  }

  RemoveLayout(suppressUpdate) {
    var aLayout = this.GetSelectedLayout();
    if (!aLayout) return null;
    this.fBoxStylesMgr.RemoveLayout(aLayout);
    if (!suppressUpdate) this.UpdatePanel(null);

    return true;
  }

  ShuffleLayout(direction) {
    var firstLayout = this.GetSelectedLayout();
    if (!firstLayout) return;
    this.fBoxStylesMgr.ShuffleLayout(firstLayout, direction);
    this.UpdatePanel(firstLayout);
  }

  IsFirstLayout(aLayout) {
    if (this.fBoxStylesMgr == null) return false;

    return this.fBoxStylesMgr.IsFirstLayout(aLayout);
  }

  IsLastLayout(aLayout) {
    if (this.fBoxStylesMgr == null) return false;

    return this.fBoxStylesMgr.IsLastLayout(aLayout);
  }

  AddBoxStyle() {
    if (this.fBoxStylesMgr == null) return;

    var selection = this.fWSMgr.GetFirstSelectedElement(enumChartElement.chartBox);
    const hierarchyType = this.fBoxStylesMgr.GetHierarchyType();
    var l;
    if (selection == null) {
      var previewObj = this.GetPreviewObject();
      l = this.fWSMgr.GetBlankLayout(previewObj);
    } else l = selection.GetLayout();
    var newLayout = l.Clone();
    newLayout.SetIsBoxStyle(true);
    newLayout.fDirty = true;

    if (hierarchyType != null) {
      newLayout.SetHierarchyType(hierarchyType);
      if (
        hierarchyType === enumHierarchyTypes.positions ||
        hierarchyType === enumHierarchyTypes.grouping
      ) {
        newLayout.SetContainerType(enumContainerType.standardmrb);
        newLayout.SetBoxType(enumBoxType.nonstandard);
        newLayout.SetBoxSubType(enumBoxSubTypes.refMRBox);
      }
    }
    this.fBoxStylesMgr.AddLayout(newLayout);
    this.UpdatePanel(newLayout);

    var eventTracker = this.fWSMgr.GetUsageTracker();
    eventTracker.ReportEvent("box_layout_editor.box_style.created");

    return newLayout;
  }

  GetOriginalLayout() {
    return this.fOriginalLayout;
  }

  SetOriginalLayout(originalLayout) {
    this.fOriginalLayout = originalLayout;
  }

  GetPreviewObject() {
    var w = this.fWSMgr;
    var theDoc = w.GetDoc();
    var previewObj = theDoc.GetRootObj();
    if (!previewObj) return null;

    // Cloned data object does not have transient properties like filtered or muted
    var cleanPreviewObj = previewObj.Clone(true);
    return cleanPreviewObj;
  }

  EditBoxStyle() {
    if (this.fBoxStylesMgr == null) return;

    var curStyle = this.GetSelectedBoxStyle();
    var w = this.fWSMgr;
    if (!curStyle || w.GetDoc() == null) return;
    this.fOriginalLayout = curStyle.GetLayout();

    var editLayout = this.CloneSelectedLayout();
    var previewObj = this.GetPreviewObject();

    editLayout.SetDBObj(previewObj);

    var curDoc = this.fWSMgr.GetDoc();
    editLayout.SetDocRef(curDoc);

    var eventTracker = this.fWSMgr.GetUsageTracker();
    eventTracker.ReportEvent("box_layout_editor.box_style_editor.opened");

    return { editLayout, previewObj };
  }

  CopyBoxStyleToSharedStyles() {
    if (this.fBoxStylesMgr == null) return;

    var l = this.GetSelectedLayout(enumChartElement.chartBox);

    if (!l) return;
    var newLayout = l.Clone();
    newLayout.SetIsBoxStyle(true);
    this.fBoxStylesMgr.SwitchBoxStyles(enumBoxStyleSet.sharedboxstyles);
    this.fBoxStylesMgr.AddLayout(newLayout);
    return newLayout;
  }

  DuplicateBoxStyle() {
    if (this.fBoxStylesMgr == null) return;

    var l = this.GetSelectedLayout();
    if (!l) return;
    var newLayout = l.Clone();
    newLayout.SetIsBoxStyle(true);
    newLayout.fDirty = true;
    this.fBoxStylesMgr.AddLayout(newLayout);
    this.UpdatePanel(newLayout);
    return newLayout;
  }

  UpdateBoxStyle(updateLayout, curLayout) {
    this.fWSMgr.UpdateBoxStyle(updateLayout, curLayout);
  }

  ReplaceBoxStyle() {
    if (this.fBoxStylesMgr == null) return;

    var selection = this.fWSMgr.GetFirstSelectedElement(enumChartElement.chartBox);
    if (!selection) return;

    var l = selection.GetLayout();
    var oldLayout = this.GetSelectedLayout();
    //var oldLayout = oldBox.GetLayout();

    this.UpdateBoxStyle(l, oldLayout);
  }

  GetSelectedLayout() {
    var curStyle = this.GetFirstSelectedElement(enumChartElement.chartBox);
    if (curStyle == null) return null;

    var l = curStyle.GetLayout();
    return l;
  }

  UpdateLayoutName(newName) {
    var curStyle = this.GetSelectedLayout();
    if (curStyle == null) return null;
    curStyle.SetBoxStyleName(newName);
    curStyle.fDirty = true;
    this.SetBoxStylesDirty();
    this.UpdatePanel(null);
  }

  GetSelectedBoxStyle() {
    var curStyle = this.GetFirstSelectedElement(enumChartElement.chartBox);
    if (curStyle == null) return null;
    return curStyle;
  }

  CloneSelectedLayout() {
    //Used for edit box style
    var curStyle = this.GetSelectedBoxStyle();
    if (curStyle == null) return null;

    var l = curStyle.GetLayout();
    var curDoc = this.fWSMgr.GetDoc();
    var cloneLayout = this.fBoxStylesMgr.CloneLayout(l, curDoc); //this.fWSMgr
    cloneLayout.fBoxStyleID = l.fBoxStyleID;
    cloneLayout.fBoxStyleName = l.fBoxStyleName;
    return cloneLayout;
  }

  ApplyBoxStyle() {
    var w = this.fWSMgr;
    var sList = w.GetSelectedBoxes(false);
    if (sList == null || sList.length == 0) return;

    var cloneLayout = this.CloneSelectedLayout();
    if (!cloneLayout) return;

    var cloneType = cloneLayout.GetContainerType();

    for (var aBoxIdx in sList) {
      if (cloneType != sList[aBoxIdx].GetContainerType()) return;
    }

    var curDoc = this.fWSMgr.GetDoc();
    cloneLayout.SetDocRef(curDoc);

    w.StartCheckPoint();
    w.ApplyLayoutToBoxList(cloneLayout, sList, null, true);
    w.EndCheckPoint();
  }

  ExecuteCommand(aCmd) {
    var theCode = aCmd.GetCmdCode();
    if (theCode == null) return false;
    var handled = this.DoPagingCommand(theCode);
    if (handled) return handled;
    var srcElement = aCmd.GetSourceElement();
    var wsMgr = this.fWSMgr;
    var cmdProcessor = theCode.split("-");
    if (cmdProcessor.length > 1 && cmdProcessor != theCode) {
      theCode = cmdProcessor.shift();
      var subCode = cmdProcessor.join("-");
    }

    switch (theCode) {
      case "section":
        this.fCurrentTab = subCode;
        this.SwitchBoxStyleSet(subCode);
        handled = true;
        break;
      case "AddBoxStyle":
      case "EditBoxStyle":
      case "ReplaceBoxStyle":
      case "ShuffleBoxStyleUp":
      case "ShuffleBoxStyleDown":
      case "ApplyBoxStyle":
      case "RenameBoxStyle":
      case "DuplicateBoxStyle":
      case "CopyBoxStyle":
      case "DeleteBoxStyles":
      case "OKDeleteBoxStyles":
        this.DoBoxStyleCmd(theCode);
        handled = true;
        break;
      case "OKChgName":
        this.UpdateLayoutName(aCmd["newvalue"]);
        break;
      case "LoadBoxStyles":
        this.fWSMgr.LoadBoxStyles();
        break;
      case "SaveBoxStyles":
        // Legacy fire-and-forget: route rejection to UploadBoxStylesResult's QAlert path.
        this.fWSMgr.SaveBoxStyles().catch(() => this.fWSMgr.UploadBoxStylesResult(false));
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  SwitchBoxStyleSet(theCode) {
    if (!this.fBoxStylesMgr) return;

    var boxStyleSet = enumBoxStyleSet.userboxstyles;
    switch (theCode) {
      case "User":
        boxStyleSet = enumBoxStyleSet.userboxstyles;
        break;
      case "Shared":
        boxStyleSet = enumBoxStyleSet.sharedboxstyles;
        break;
      default:
        boxStyleSet = enumBoxStyleSet.systemboxstyles;
    }

    localStorage.boxstyleset = boxStyleSet;

    this.fBoxStylesMgr.SwitchBoxStyles(boxStyleSet);
    this.UpdatePanel();
  }

  DoBoxStyleCmd(theCode) {
    var handled = true;
    var selectedLayout = this.GetSelectedLayout();
    var eventTracker = this.fWSMgr.GetUsageTracker();
    eventTracker.fPanel = "Box Styles Panel";
    switch (theCode) {
      case "AddBoxStyle":
        selectedLayout = this.AddBoxStyle();
        break;
      case "EditBoxStyle":
        this.EditBoxStyle();
        break;
      case "ReplaceBoxStyle":
        this.ReplaceBoxStyle();
        break;
      case "OKDeleteBoxStyles":
        this.OKDeleteBoxStyles();
        break;
      case "DeleteBoxStyles":
        this.RemoveLayouts();
        break;
      case "ShuffleBoxStyleUp":
      case "ShuffleBoxStyleDown":
        this.ShuffleLayout(theCode == "ShuffleBoxStyleUp");
        break;
      case "ApplyBoxStyle":
        this.ApplyBoxStyle();
        break;
      case "RenameBoxStyle":
        this.DoEditBoxStyleName();
        break;
      case "DuplicateBoxStyle":
        selectedLayout = this.DuplicateBoxStyle();
        break;
      case "CopyBoxStyle":
        selectedLayout = this.CopyBoxStyleToSharedStyles();
        break;
      default:
        handled = false;
    }
    this.SelectLayout(selectedLayout);
  }

  SelectLayout(selectedLayout) {
    var theList = this.fElements;
    var n = theList.length;

    for (var i = 0; i < n; i++) {
      var theElement = theList[i];
      if (theElement.fObjectName != "QChartBox") continue;
      var aLayout = theElement.GetLayout();
      var theID = aLayout.GetBoxStyleID();
      if (theID == selectedLayout.GetBoxStyleID()) {
        this.DoSelectElement(theElement, true);
        this.PanToNextElement(theElement);
        break;
      }
    }
  }

  GetBoxStyleIDsForSelection() {
    var theList = [];

    var selList = this.GetSelectionList(enumChartElement.chartBox);
    var n = selList.length;

    for (var i = 0; i < n; i++) {
      var aLayout = selList[i].GetLayout();
      var theID = aLayout.GetBoxStyleID();
      theList.push(theID);
    }

    return theList;
  }

  IsUniqueBoxStyleName(theName, curLayout) {
    return this.fBoxStylesMgr.IsUniqueBoxStyleName(theName, curLayout);
  }

  GetBoxStylesMgr() {
    return this.fBoxStylesMgr;
  }

  DoEditBoxStyleName() {
    // Unused(?)
    // var s = new QRenamePanel();
    // var curBoxStyle = this.GetSelectedLayout();
    // if (!curBoxStyle) return;
    // var name = curBoxStyle.GetBoxStyleName();
    //TODO: Appstring
    // s.InitRenamePanel(
    //   this.fWSMgr,
    //   this,
    //   "Rename Box Style",
    //   "Style Name",
    //   "Enter box Style Name",
    //   "OKChgName",
    //   name,
    //   1,
    //   false,
    //   2,
    //   false
    // );
    //TODO: No no values here.
    // s.SetNoNoValues();
    //s.InitChangeBoxStyleName(this.fWSMgr, this);
    //this.fWSMgr.PushPanel(s);
    //s.BecomeKeyboardTarget();
  }

  DoHandleRightClick(hitElement, x, y) {
    var uInfo = this.fWSMgr.GetUserInfo();
    var allowEdit = uInfo.CanUpdateTemplates() && this.fBoxStylesMgr.CurrentBoxStyleSet();
    if (!allowEdit) return;

    var s = null;
    var w = this.fWSMgr;
    if (hitElement) {
      var elementType = hitElement.GetElementType();
      if (elementType == enumChartElement.chartBox) {
        s = new QBSRightClick();
        this.ClearSelection();
        this.DoSelectElement(hitElement, true);
      }
    }

    if (s) {
      s.InitMenu("BoxStyleRightClick", w, x, y);
      s.fBoxStylesPanel = this;
      w.PushPanel(s);
    }
  }

  HandleRightClickCmd(cmdCode, aCmd) {
    this.DoBoxStyleCmd(cmdCode);
  }

  ExecuteAlertCommand(aCmd) {
    this.ExecuteCommand(aCmd);
  }

  ObjectName() {
    return "QBoxStylesPanel";
  } /**/
}
